import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function RefundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>

        <h1 className="font-heading text-3xl font-semibold text-foreground mb-8">
          Refund Policy
        </h1>

        <div className="space-y-6 text-muted-foreground">
          <p>
            Please read our refund policy carefully:
          </p>

          <div className="space-y-4">
            <div>
              <h3 className="text-foreground font-medium mb-2">Digital Products</h3>
              <p className="text-sm">
                As Decisora provides digital services, purchases are generally non-refundable 
                once access is granted.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Exceptions</h3>
              <p className="text-sm">
                Technical issues or accidental payments can be reported within 24 hours 
                of purchase for review.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Genuine Cases</h3>
              <p className="text-sm">
                Genuine cases will be reviewed and may be refunded at our discretion. 
                Please provide details when contacting support.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">Abuse Prevention</h3>
              <p className="text-sm">
                Abuse of the refund policy may lead to account restrictions.
              </p>
            </div>

            <div>
              <h3 className="text-foreground font-medium mb-2">How to Request</h3>
              <p className="text-sm">
                Contact us at{" "}
                <a href="mailto:decisora.help@gmail.com" className="text-primary hover:underline">
                  decisora.help@gmail.com
                </a>
                {" "}with your payment details and reason for refund.
              </p>
            </div>
          </div>

          <p className="text-xs text-muted-foreground/70 pt-4">
            Last updated: February 2026
          </p>
        </div>
      </div>
    </div>
  );
}
